// Layout
import { DefaultLayout } from '../layouts';
import EndUserLayout from '../layouts/EndUserLayout';

// EUI Pages
import Products from '../pages/products/productindex.js';
import ProductDetails from '../pages/products/productdetails.js';
import Cart from '../pages/cart';
import Quote from '../pages/quote';
import Contact from '../pages/contact/contact.js';
import MyAccount from '../pages/my-account/myaccountindex.js';
import { ProjectConfirmation } from '../pages/cart/ProjectConfirmation';
import Typical from '../pages/typical';
import TypicalLayouts from '../pages/typical-layouts/typicalindex.js';
import SurveyDetail from '../pages/survey/surveyindex';
import PrivacyPolicy from '../pages/legal/privacy-policy';
import Terms from '../pages/legal/terms';
import Home from '../pages/home';
import Main from '../pages/main/main'; 
import TypicalLayoutProductReview from '../pages/typical/typicalLayoutProductReview';

export const appRoutes = [
	{
		path: '/',
		element: Main,
		secure:false
	},
	{
		path: '/home',
		element: Home,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/category/:slugs/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/manufacturers/:mIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/category/:slugs/manufacturers/:mIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/dealers/:dIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/category/:slugs/dealers/:dIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/manufacturers/:mIds/dealers/:dIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/category/:slugs/manufacturers/:mIds/dealers/:dIds/:sort?',
		element: Products,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/sort/:sort',
		element: Products,
		layout: DefaultLayout,
		secure: true
	}, 
	{
		path: '/products/:id?/:slug',
		element: ProductDetails,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/products/:slug/preview',
		element: ProductDetails,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/:layoutSlug/products/:id/:slug/:cartId/:typicalId/:schoolId/review',
		element: TypicalLayoutProductReview,
		layout: DefaultLayout,
		secure: true,
	}, 
	{
		path: '/my-project',
		element: Cart,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/my-quote/:quoteId?',
		element: Quote,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/contact',
		element: Contact,
		layout: DefaultLayout,
		secure: false
	},
	{
		path: '/my-quotes',
		element: MyAccount,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/confirmation',
		element: ProjectConfirmation,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/typical-layout/:slug',
		element: Typical,
		layout: DefaultLayout,
		secure: false
	},
	{
		path: '/typical-layout/:category/:slug',
		element: Typical,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/typical-layouts',
		element: TypicalLayouts,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/typical-layouts/category/:slug',
		element: TypicalLayouts,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/surveys',
		element: SurveyDetail,
		layout: DefaultLayout,
		secure: true
	},
	{
		path: '/privacy-policy',
		element: PrivacyPolicy,
		layout: EndUserLayout,
		secure: false
	},
	{
		path: '/terms-of-service',
		element: Terms,
		layout: EndUserLayout,
		secure: false
	},
];
